<div class="ds-modal pdf">
    <div class="ds-accent"></div>

    <div class="ds-modal__head">
        <span class="ds-modal__head-icon material-icons">picture_as_pdf</span>
        <h2>{{ data.tituloDocumento }}</h2>
        <span class="ds-modal__spacer"></span>
        <button type="button" class="ds-icon-btn" (click)="closeModal()" aria-label="Cerrar">
            <span class="material-icons">close</span>
        </button>
    </div>

    <div class="ds-modal__body pdf__body">
        <iframe [src]="path | safeResourceUrl" type="application/pdf" class="pdf__frame"></iframe>
    </div>

    <div class="ds-modal__actions">
        <button type="button" class="ds-pill ds-pill--primary" (click)="closeModal()">Cerrar</button>
    </div>
</div>
